import React from 'react'
import {useTranslation} from 'i18n'
import {FirebaseMessageRoomItemPayload} from 'types'
import {Paragraph} from 'common/components'

export interface GiftShopMessageRoomContentItemNotificationRejectInvitationAdminHostProps {
  payload: FirebaseMessageRoomItemPayload['notification_reject_invitation_admin_host']
}

export default function GiftShopMessageRoomContentItemNotificationRejectInvitationAdminHost({
  payload: {host_member_username, host_tag, username},
}: GiftShopMessageRoomContentItemNotificationRejectInvitationAdminHostProps) {
  const {translate} = useTranslation()

  return (
    <>
      <Paragraph fontSize="m">
        {translate('messages:hiUsername', {username})}
      </Paragraph>
      <br />
      <Paragraph fontSize="m">
        {translate('messages:notificationHostAdminInvitationRejected', {
          host_member_username,
          host_tag,
        })}
      </Paragraph>
    </>
  )
}
